<template>    
  <MissionDetailScienceGraphicsListGen v-if="canShowGraph" :uiid="uiid" :isleft="isleft" :mission="infosSimMission.mission" :tabState="simulationState" @selectGraph="selectGraph($event)" />
  <div v-else ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">
    <span class="display-2" style="margin:auto">{{$t('Pilot.Nmea.NoDataAvailable')}}</span>
  </div>
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import MissionDetailScienceGraphicsListGen from '@/components/mission/MissionDetailScienceGraphicsListGen.vue'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'

@Component({
  name: 'SimulationDetailScienceGraphicsList',
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  },
  components:{MissionDetailScienceGraphicsListGen}
})
export default class SimulationDetailScienceGraphicsList extends Vue {      

  isleft!:boolean
  uiid!:string

  get canShowGraph(){
    return this.infosSimMission?.result?.simulation_state == 'finished' || this.infosSimMission?.result?.simulation_state == 'aborted'
  }

  get simUiid()
  {
    return `${this.uiid}_${this.bestFitMisId}`
  }


  get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get simulationState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState         
  }

  get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

  get infosSimMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get map_uiid(){
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,'map')
 }

 get mapState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.map_uiid) as MapUiState         
 }

 get bestFitMisId(){
   return this.mapState?.bestFitMisId
 }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }

  selectGraph(graph:any){            

    //@ts-ignore
      this.$store.myActions.UI_NAVTO_DETAIL({cmp:'SimulationDetailScienceGraphics',uiid:this.simulation_uiid,isleft:!this.isleft,'label':graph.name}).then(() => {
        const tabsMission = !this.isleft? this.simulationState.tabsleft: this.simulationState.tabsright
        //on attend que le composant soit créé
        this.$nextTick(()=> this.$store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsMission.selected}))
      })        
    }

  }
</script>
